<template>
  <div>
      <!--Header Components-->
      <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>
        </b-row>
      </base-header>
    <b-container fluid class="mt--6">
       <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-row>
            <b-col sm="12">
                <div class="card-wrapper">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <b-row>
                                <b-col cols="8">
                                    <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                                </b-col>
                                 <b-col cols="4">
                                  <base-button type="success" @click="clickOnNew" class="float-right mr-4">
                                        <i class="fa fa-plus"></i>
                                  </base-button>                                  
                                  <base-button type="info" @click="clickOnDownloadSelectCategory" class="float-right mr-4" v-if="productCategories.length > 0">
                                      <i class="fa fa-download"></i>
                                  </base-button>
                                 </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col md="7" >
                                <base-input :label="language_terms['QUICK_FILTER']" v-model="filter.keyword" v-on:keyup.enter="clickOnSearch">
                                </base-input>
                            </b-col>
                            <!-- <b-col md="2">
                              <base-input :label="language_terms['TYPE']">
                                <el-select v-model="filter.type" filterable :placeholder="language_terms['TYPE']">
                                    <el-option
                                        v-for="option in typeOptions"
                                        :key="option.code"
                                        :label="language_terms[option.name]"
                                        :value="option.code">
                                    </el-option>
                                </el-select>
                                </base-input>
                            </b-col> -->
                            <b-col md="2">
                              <base-input :label="language_terms['DATE_FROM']" >
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="filter.date_from">
                                </flat-picker>
                              </base-input>
                            </b-col>
                            <b-col md="2">
                              <base-input :label="language_terms['DATE_TO']" >
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="filter.date_to">
                                </flat-picker>
                              </base-input>
                            </b-col>
                            <!-- <b-col md="2">
                                <base-input :label="language_terms['DIRECTION']">
                                <el-select
                                    v-model="filter.direction"
                                    filterable
                                    :placeholder="language_terms['DIRECTION']"
                                    >
                                    <el-option
                                        v-for="option in directionOptions"
                                        :key="option.code"
                                        :label="language_terms[option.name]"
                                        :value="option.code">
                                    </el-option>
                                </el-select>
                                </base-input>
                            </b-col> -->
                            <b-col cols="1" class="mt-4">
                              <base-button type="primary" @click="clickOnSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                          </b-col>
                        </b-row>
                    </b-card>
                    <PaginatedTables :myColumns="tableColumns" :tableData="items" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0"/>
                </div>
            </b-col>
        </b-row>

        <b-modal v-model="modalDownload" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" size="lg" centered class="my-modal" ok-only>
          <template #modal-title>
              <span style="color: white">{{language_terms['CATEGORY'] + ' ' + language_terms['DOWNLOAD']}}</span>
          </template>
          <b-row>
            <b-col md="10" class="mb-3">
              <base-input :label="language_terms['CATEGORY']">
                <el-select v-model="product_category_id" filterable :placeholder="language_terms['CATEGORY']">
                    <el-option
                        v-for="option in productCategories"
                        :key="option.id"
                        :label="option.name"
                        :value ="option.id">
                    </el-option>
                </el-select>
              </base-input>
            </b-col>
            <b-col md="1" class="mt-2">
              <base-button type="info" @click="clickOnDownload(false)" class="float-right mt-4" :disabled="product_category_id == null">
                <i class="fa fa-download"></i>
              </base-button>
            </b-col>
            <b-col md="1" class="mt-2">
              <base-button type="success" @click="clickOnDownload(true)" class="float-right mt-4">
                <i class="fa fa-download"></i>
              </base-button>
            </b-col>              
          </b-row>
      </b-modal>        
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Select, Option } from "element-ui";

import PaginatedTables from '@/views/Tables/PaginatedTables'

export default {
  components: {
    Loading,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    PaginatedTables
  },
  data() {
    return {
      product_category_id: null,
      productCategories:[],
      headerBgVariant: "primary",
      headerTextVariant: "light",
      modalDownload: false,
      directionOptions:[
        {code:"ALL", name:"ALL"},
        {code:"IN", name:"STOCK_IN"},
        {code:"OUT", name:"STOCK_OUT"}
      ],
      typeOptions:[
        {code:"ADJUSTMENT", name:"ADJUSTMENT"},
        {code:"DO_SO", name:"DO_FROM_SO"},
        {code:"DO", name:"DELIVERY_ORDER"},
        {code:"GRN", name:"GOOD_RECEIVE_NOTE"},
        {code:"GRN_PO", name:"GRN_FROM_PO"},
        {code:"STOCKTRANSFER", name:"STOCKTRANSFER"}
      ],
      loading:false,
      filter:{
        keyword:"",
        date_from:null,
        date_to:null,
        direction:'ALL',
        type:'ADJUSTMENT'
      },
      items:[],
      tableColumns: [
        {
          prop: "code",
          label: "Code",
          minWidth: 100,
          sortable: true,
          key:"CODE"
        },
        {
          prop: "date",
          label: "DATE",
          minWidth: 120,
          sortable: true,
          key:"DATE"
        },
        {
          prop: "items_count",
          label: "ITEMS",
          minWidth: 120,
          sortable: true,
          key:"ITEMS"
        },
        {
          prop: "time_created",
          label: "TIME_CREATED",
          minWidth: 100,
          sortable: true,
          key:"TIME_CREATED"
        },
      ]
    };
  },
  mounted(){
    this.updateTableLang()
    this.loadCategories()
  },

  computed:{
    ...mapState({
      language_terms:(state)=>state.languages.language_terms,
    })
  },

  watch:{
    language_terms:{
            handler(val){
                this.updateTableLang()
            },
        }
  },
  methods:{
    async loadCategories()
    {
      axios.post(apiRoutes['PRODUCT_CATEGORIES_QUICK_SEARCH'], [], authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            this.productCategories =  response.data.data
          } else {
            this.productCategories = []
          }
        })
        .catch(error => {
          if (error.response) {
              Vue.notify({group: 'notify', type: 'error', text: error.response.data.msg, max: 5, duration: 5000, speed: 300})
          }
      });

    }
    ,
    async clickOnDownload(is_all_categories)
    {
      let url = ''

      this.isLoading = true

      if (is_all_categories)
        url = apiRoutes["INVENTORY_DOWNLOAD_STOCKTAKE_TEMPLATE"] + "" 
      else
        url = apiRoutes["INVENTORY_DOWNLOAD_STOCKTAKE_TEMPLATE"] + "?product_category_id=" + encodeURIComponent(this.product_category_id) 

      // alert(url)
      axios.get(url, { responseType: 'blob' })
      .then(response => {
        // alert(response.headers["content-disposition"])
        // let fileName = response.headers["content-disposition"].split(
        //       "filename="
        //     )[1];
        // alert(fileName)        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        //link.download = this.product_category_id + '.xlsx'
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
  
      // let payload = []
      // let url = apiRoutes["INVENTORY_DOWNLOAD_STOCKTAKE_TEMPLATE"] + "?product_category_id=" + encodeURIComponent(this.product_category_id) 
      // alert(url)
      // await axios.post(url, payload, authHeader()).then((response) => {
      //   var fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      //   var fileLink = document.createElement('a');

      //   fileLink.href = fileURL;
      //   fileLink.setAttribute('download', this.product_category_id + '.xlsx');
      //   document.body.appendChild(fileLink);

      //   fileLink.click();
      // })
      // .catch((error) => {
      //   if (error.response) {
      //     Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300, });
      //   }
      // });
      this.isLoading = false

    },
    async clickOnDownloadSelectCategory()
    {
      this.modalDownload = true
    },
    async clickOnSearch()
    {
        let filter = this.filter
        let payload = {keyword: filter.keyword, date_from:filter.date_from, date_to:filter.date_to}
        await axios.post(apiRoutes["STOCKADJUSTMENTS_QUICKSEARCH"], payload, authHeader()).then((response) => {
              if (response.data.code == 1) {
                this.items = response.data.data;
              } else {
                this.items = [];
              }

              this.isLoading = false;
            })
            .catch((error) => {
              if (error.response) {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300, });
              }
            });
      },
      clickOnNew()
      {
          this.$router.push("/inventory/stockadjustment/_new")
      },
      updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]

      }
    },

  }
};
</script>


<style>
</style>